(function () {
  'use strict';

  var root = document.querySelector('[data-devid-assistant-v2]');
  if (!root) return;

  var launcher = root.querySelector('[data-assistant-launcher]');
  var dismissButton = root.querySelector('[data-assistant-launcher-dismiss]');
  var restoreButton = root.querySelector('[data-assistant-launcher-restore]');
  var panel = root.querySelector('[data-assistant-panel]');
  var input = root.querySelector('[data-assistant-input]');
  var endpoint = (root.getAttribute('data-endpoint') || '').trim();
  var storageKey = 'devid_assistant_launcher_minimized';

  if (!launcher || !panel || !input) return;

  function readMinimizedState() {
    try {
      return window.sessionStorage.getItem(storageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function writeMinimizedState(isMinimized) {
    try {
      if (isMinimized) window.sessionStorage.setItem(storageKey, '1');
      else window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      // Storage can be unavailable in strict privacy modes. The UI still works for the current page.
    }
  }

  function setMinimized(isMinimized, shouldFocus) {
    root.classList.toggle('is-launcher-dismissed', isMinimized);
    if (restoreButton) restoreButton.hidden = !isMinimized;
    writeMinimizedState(isMinimized);

    if (shouldFocus) {
      var target = isMinimized ? restoreButton : launcher;
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    }
  }

  setMinimized(readMinimizedState(), false);

  if (dismissButton) {
    dismissButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMinimized(true, true);
    });
  }

  if (restoreButton) {
    restoreButton.addEventListener('click', function () {
      setMinimized(false, true);
    });
  }

  if (window.matchMedia('(max-width: 749px)').matches) {
    launcher.addEventListener('click', function () {
      window.setTimeout(function () {
        if (document.activeElement === input) input.blur();
        panel.focus({ preventScroll: true });
      }, 70);
    });
  }

  /*
   * Conversation task router
   * ------------------------
   * The visual thread can remain intact, but the payload sent to the backend must contain
   * only the current task context. This prevents a completed order lookup from hijacking
   * later requests such as product advice, returns or outfit building.
   */
  if (!endpoint || typeof window.fetch !== 'function' || window.__devidAssistantTaskRouterInstalled) return;
  window.__devidAssistantTaskRouterInstalled = true;

  var originalFetch = window.fetch.bind(window);
  var routerConversationState = null;
  var activeTask = null;

  function normalize(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’']/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function hasOrderNumber(value) {
    return /(?:^|\s)#?\d{3,12}(?:\s|$)/.test(value || '');
  }

  function hasEmail(value) {
    return /[^\s@]+@[^\s@]+\.[^\s@]+/.test(value || '');
  }

  function classifyTask(value) {
    var query = normalize(value);
    if (!query) return null;

    if (/\b(dov e il mio ordine|dove e il mio ordine|stato ordine|tracking ordine|traccia ordine|where is my order|track my order|order status|order tracking)\b/.test(query)) return 'order';
    if (/\b(reso|resi|cambio|cambi|restituire|return|returns|exchange)\b/.test(query)) return 'returns';
    if (/\b(tempi di spedizione|spedizione|inpost|contrassegno|pagamento alla consegna|shipping|delivery|cash on delivery|cod|prodotti originali|originali|rivenditore autorizzato|authentic|authorized retailer|guida taglie|taglia|size guide|sizing)\b/.test(query)) return 'support';
    if (/\b(crea un look|consigliami un look|look|outfit|abbinamento|abbina|build a look|style me)\b/.test(query)) return 'look';
    if (/\b(aiutami a scegliere|consiglio prodotto|cerco un prodotto|prodotto giusto|recommend|help me choose|product advice|sprayground|saint barth|mc2|k-way|kway|replay|devid label|t-shirt|tshirt|polo|pantaloni|cargo|jeans|bermuda|shorts|maglieria|giacca|costume|zaino|borsa|scarpe|sneaker)\b/.test(query)) return 'product';
    return null;
  }

  function isBroadOrderRestart(query) {
    return classifyTask(query) === 'order' && !hasOrderNumber(query) && !hasEmail(query);
  }

  function isOrderContinuation(query, state) {
    if (!state || state.flow !== 'order_lookup') return false;
    if (isBroadOrderRestart(query)) return false;

    var strongTask = classifyTask(query);
    if (strongTask && strongTask !== 'order') return false;

    // A number entered while the order flow is active is always a new or corrected order number.
    // It must never be reclassified as a product code when the assistant was waiting for email.
    if (hasOrderNumber(query)) return true;
    if (state.next_step === 'email') return hasEmail(query);
    if (state.next_step === 'lookup') return /\b(riprova|riprovare|retry|prova ancora|try again)\b/.test(normalize(query));
    return false;
  }

  function currentMessageOnly(query) {
    return query ? [{ role: 'user', content: query }] : [];
  }

  function prepareAssistantPayload(payload) {
    var query = (payload.query || payload.message || '').toString().trim();
    var task = classifyTask(query);
    var incomingState = routerConversationState || payload.conversation_state || null;
    var switchingTask = Boolean(task && activeTask && task !== activeTask);

    if (incomingState && incomingState.flow === 'order_lookup' && !isOrderContinuation(query, incomingState)) {
      incomingState = null;
      switchingTask = true;
    }

    if (isBroadOrderRestart(query)) {
      incomingState = null;
      switchingTask = true;
    }

    if (switchingTask) {
      payload.messages = currentMessageOnly(query);
    }

    payload.conversation_state = incomingState;
    if (task) activeTask = task;
    return payload;
  }

  function updateRouterFromResponse(payload) {
    if (!payload || typeof payload !== 'object') return;

    var orderStatus = payload.order_lookup && payload.order_lookup.status;
    var nextStep = payload.conversation_state && payload.conversation_state.next_step;
    var terminalOrder = orderStatus === 'found' || orderStatus === 'marketplace_unsupported' || nextStep === 'none';

    if (payload.type === 'order_help' && payload.conversation_state && !terminalOrder) {
      routerConversationState = payload.conversation_state;
      activeTask = 'order';
      return;
    }

    routerConversationState = null;
    if (payload.type === 'product_advice') activeTask = 'product';
    else if (payload.type === 'faq') activeTask = 'support';
    else if (payload.type !== 'order_help') activeTask = null;
  }

  window.fetch = function (resource, options) {
    var requestUrl = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var absoluteRequestUrl = '';
    var absoluteEndpoint = '';

    try {
      absoluteRequestUrl = new URL(requestUrl, window.location.href).href;
      absoluteEndpoint = new URL(endpoint, window.location.href).href;
    } catch (error) {
      return originalFetch(resource, options);
    }

    if (absoluteRequestUrl !== absoluteEndpoint || !options || String(options.method || 'GET').toUpperCase() !== 'POST' || typeof options.body !== 'string') {
      return originalFetch(resource, options);
    }

    var nextOptions = Object.assign({}, options);
    try {
      var payload = JSON.parse(options.body);
      nextOptions.body = JSON.stringify(prepareAssistantPayload(payload));
    } catch (error) {
      return originalFetch(resource, options);
    }

    return originalFetch(resource, nextOptions).then(function (response) {
      response.clone().json().then(updateRouterFromResponse).catch(function () {});
      return response;
    });
  };
})();
